/* eslint-disable */

export default (progress, dream=false) =>
  progress >= 75 ? 'dark' :
    progress > (dream ? 0 : 20) ? 'dark' :
      'dark'
